import { styled } from "@pigment-css/react";

export const EmptyState = styled("div")(({ theme }) => ({
  flex: 1,
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  justifyContent: "center",
  gap: theme.fieldSalesTwo.spacing[12],
  padding: theme.fieldSalesTwo.spacing[24],
  textAlign: "center",
  color: theme.fieldSalesTwo.colors.neutral[500],
  "& svg": { width: theme.fieldSalesTwo.spacing[32], height: theme.fieldSalesTwo.spacing[32] },
}));

export const EmptyTitle = styled("p")(({ theme }) => ({
  margin: 0,
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size.base,
  fontWeight: theme.fieldSalesTwo.font.weight[520],
  color: theme.fieldSalesTwo.colors.neutral[900],
}));

export const EmptySubtitle = styled("p")(({ theme }) => ({
  margin: 0,
  maxWidth: "16rem",
  fontFamily: theme.fieldSalesTwo.font.family,
  fontSize: theme.fieldSalesTwo.font.size[14],
  lineHeight: theme.fieldSalesTwo.font.lineHeight[148],
  color: theme.fieldSalesTwo.colors.neutral[700],
}));
